import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NgSelectModule } from '@ng-select/ng-select';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { RouterModule } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { CurrencyFilterPipe } from '../service/currency-filter.pipe';
import { PermissionPipe } from './permission.pipe';
import { MultiOrderPipe } from './multi.order.pipe';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { SidenavBtnComponent } from './components/sidenav/sidenav-btn/sidenav-btn.component';
import { MatRippleModule } from '@angular/material/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LogoutComponent } from './components/logout/logout.component';
import { AccordionModule } from './components/accordion/accordion.module';
import { NgxBootstrapConfirmComponent } from "./components/ngx-bootstrap-confirm/ngx-bootstrap-confirm.component";
import { NgxBootstrapConfirmService } from "./components/ngx-bootstrap-confirm/ngx-bootstrap-confirm.service";
import { AngularMyDatePickerModule } from '@nodro7/angular-mydatepicker';

const declareExport = [
  HeaderComponent,
  CurrencyFilterPipe,
  PermissionPipe,
  MultiOrderPipe,
  SidenavBtnComponent,
  SidenavComponent,
  LogoutComponent,
  NgxBootstrapConfirmComponent
];

const importExport = [
  CommonModule,
  AngularMyDatePickerModule,
  MatProgressSpinnerModule,
  MatSidenavModule,
  MatRippleModule,
  NgSelectModule,
  TabsModule,
  ProgressbarModule,
  FormsModule,
  ReactiveFormsModule,
  CommonModule,
  RouterModule,
  BsDropdownModule,
  TooltipModule,
  NgxDatatableModule,
  AccordionModule
];

@NgModule({
  declarations: [
    ...declareExport
  ],
  imports: [
    ...importExport
  ],
  exports: [
    ...declareExport,
    ...importExport
  ],
  providers: [
    BsModalService,
    NgxBootstrapConfirmService
  ]
})
export class SharedModule {
}
